import React, { lazy } from 'react';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: 'https://cdn.magicpatterns.com/uploads/3qjxuShVSBUnjtDovHCLkg/Portada_1_web_png.png',
  title: 'Tomo 1 — Rutinas que Funcionan',
  subtitle: 'La base que hace posible todo lo demás.',
  desc: 'Las 5 Rutinas Base, ambiente perfecto, la Despedida de Cierre y el Plan de 7 días.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/ht6sWpt6EVr9koPHZVnYUd/Portada_2_web_png.png',
  title: 'Tomo 2 — Miedos y Pesadillas',
  subtitle: 'El Método Anti-Miedo en 4 pasos',
  desc: 'El objeto Guardián, los 3 tipos de miedo y el protocolo para pesadillas y terrores nocturnos.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/kftJ47CeWRdR1226b7fN77/Portada_3_web_png.png',
  title: 'Tomo 3 — El Niño Hiperactivo y el Sueño',
  subtitle: 'Los 5 perfiles del cerebro acelerado',
  desc: 'El Protocolo de Desactivación Sensorial, el Vaciado Cognitivo y el Plan de 21 días.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/uRP1iKfETxDUZKeJULrwhx/Portada_4_web_png.png',
  title: 'Tomo 4 — Siestas y Transiciones',
  subtitle: 'La siesta perfecta por edad',
  desc: 'El protocolo para dejar la siesta sin crisis y el plan de 28 días de transición.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/pFUUyiZizkKYowvrGHDjAY/Portada_5_web_png.png',
  title: 'Tomo 5 — Viajes, Cambios y Disrupciones',
  subtitle: 'La Mochila de Sueño',
  desc: 'El sistema Anti Jet Lag infantil, los protocolos para mudanzas, cambios de colegio y el Plan de Recuperación Universal.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/9L4HQUx7C3uk7aca757wGv/Portada_6_web_png.png',
  title: 'Tomo 6 — El Sistema Completo',
  subtitle: 'El Gran Mapa de Referencia',
  desc: 'El Diagnóstico Maestro, el Calendario Anual y el Manual de Mantenimiento para toda la vida.'
}];
const includes = ['Protocolo paso a paso listo para aplicar esta noche', 'Infografías y representaciones visuales en cada página', 'Checklists, calendarios y planillas para imprimir', 'Scripts y guiones exactos — sabés qué decir en cada momento', 'Diagnóstico específico por situación y edad', 'Planes de 7, 14, 21 y 28 días según el problema', 'Adaptado a la realidad cultural argentina', '100% PDF — sin app, sin plataforma, sin vencimiento'];
export function ProductOverview() {
  return <section id="sistema" className="py-20 bg-charcoal" data-id="element-312">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-313">
        <div className="text-center mb-16" data-id="element-314">
          <h2 className="text-sm font-bold tracking-widest text-gold uppercase mb-4" data-id="element-315">
            ZENTRAL PRO™ — MEGAPACK DESCANSO PROFUNDO LISTO
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-316">
            6 Tomos + 4 Bonos — De 1 a 12 años
          </h3>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-317">
            +300 páginas — Todo resuelto.
          </p>
        </div>

        <div className="bg-night-light rounded-2xl shadow-xl border border-white/10 overflow-hidden" data-id="element-318">
          <div className="p-6 md:p-12" data-id="element-319">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-0 divide-y divide-white/10 lg:divide-y-0 lg:gap-y-12" data-id="element-320">
              {tomos.map((tomo, i) => <div key={i} className="flex gap-6 py-8 lg:py-0 relative" data-id="element-321">
                  <div className="shrink-0 relative" data-id="element-322">
                    <img src={tomo.icon} alt={tomo.title} className="w-32 md:w-44 object-contain rounded shadow-md" loading="lazy" decoding="async" data-id="element-323" />
                    <div className="absolute -top-3 -left-3 w-8 h-8 rounded-full bg-gold text-charcoal flex items-center justify-center font-bold text-sm shadow-lg border-2 border-night-light" data-id="element-324">
                      {i + 1}
                    </div>
                  </div>
                  <div className="flex flex-col justify-center" data-id="element-325">
                    <h5 className="font-bold text-lg md:text-xl text-white mb-1" data-id="element-326">
                      {tomo.title}
                    </h5>
                    <p className="text-gold font-medium text-sm md:text-base mb-2" data-id="element-327">
                      {tomo.subtitle}
                    </p>
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-328">
                      {tomo.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-12 lg:mt-16 pt-12 border-t border-white/10" data-id="element-329">
              <h5 className="font-serif font-bold text-2xl mb-8 text-center text-white" data-id="element-330">
                Cada tomo incluye:
              </h5>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 max-w-4xl mx-auto" data-id="element-331">
                {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-332">
                    <CheckCircle2 className="w-6 h-6 text-gold shrink-0" data-id="element-333" />
                    <span className="text-base text-gray-200 font-medium" data-id="element-334">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-335">
              <a href="#precios" className="inline-block w-full sm:w-auto text-center bg-terracotta hover:bg-terracotta-light text-white font-bold py-4 px-10 rounded shadow-md hover:shadow-lg transition-all text-lg" data-id="element-336">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}